import { Component, Input, OnDestroy, OnInit } from '@angular/core';
// import 'jquery-slimscroll';

@Component({
    selector: 'ss-logo',
    templateUrl: './ss-logo.component.html',
    styleUrls: ['./ss-logo.component.css']
})
export class SSLogoComponent implements OnInit, OnDestroy {

    @Input() height: string = '25px';
    @Input() padding: string = '5px';
    @Input() isLink: boolean;
    @Input() isDark: boolean = false;


    constructor() {

    }

    ngOnInit() {

    }

    ngOnDestroy() {
    }

    setStyles() {
        let styles = {
            // CSS property names
            'height': this.height,
            'padding': this.padding,
        };
        return styles;
    }

}
